export default __webpack_public_path__ + "static/media/boxoknives.90a032bd.png";